import {
  barrierGetRequest,
  barrierPostRequest,
  barrierPutRequest,
  barrierDeleteRequest,
} from "../dataProvider";

export default class TripodUtilService {
  async get(api, config) {
    let response = await barrierGetRequest(api, config);
    return response;
  }
  async post(api, data, config) {
    let response = await barrierPostRequest(api, data, config);
    return response;
  }
  async put(api, data, config) {
    let response = await barrierPutRequest(api, data, config);
    return response;
  }
  async delete(api, config) {
    let response = await barrierDeleteRequest(api, config);
    return response;
  }
}
